export default __webpack_public_path__ + "static/media/Warhoof Boots.b8c88da0.jpg";